import createClient from 'openapi-fetch';
import type { paths } from './schema.gen.ts';

export const api = createClient<paths>({
  baseUrl: '/api',
  credentials: 'include',
  fetch: (request) => globalThis.fetch(request),
});

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly reason = '',
    readonly slug = '',
  ) {
    super(`The API answered ${status}`);
  }
}

export const reasonOf = (error: unknown): string => {
  if (error instanceof ApiError) return error.reason;
  throw error;
};
